export default "__VITE_ASSET__387af839__"